import ScreenUserCreate from 'screens/User/Create';
import ScreenUserUpdate from 'screens/User/Update';
import ScreenUserList from 'screens/User/List';
import ScreenUserDetails from 'screens/User/Details';
import ScreenUserPermission from 'screens/User/Permission';
import ScreenUserAgencyList from 'screens/UserAgency/List';
import ScreenUserChangePassword from 'screens/User/ChangePassword';
import { USER, AGENCY } from './paths';

const usersRoutes = [
  {
    path: USER.CHANGE_PASSWORD,
    name: 'Change Password First Login',
    component: ScreenUserChangePassword,
    loginRequired: true,
  },
  {
    path: USER.PERMISSION,
    name: 'UserPermission',
    component: ScreenUserPermission,
    allowPermissions: ['change_permission'],
  },
  {
    path: USER.CREATE,
    name: 'UserCreate',
    component: ScreenUserCreate,
    loginRequired: true,
    allowPermissions: [
      'add_user',
      'add_agency',
      'add_useragency',
      'add_ownership_useragency',
    ],
  },
  {
    path: USER.UPDATE,
    name: 'UserUpdate',
    component: ScreenUserUpdate,
    loginRequired: true,
    allowPermissions: [
      'change_user',
      'change_agency',
      'change_useragency',
      'change_ownership_useragency',
    ],
  },
  {
    path: USER.DETAILS,
    component: ScreenUserDetails,
    loginRequired: true,
  },
  {
    path: USER.LIST,
    name: 'UserList',
    component: ScreenUserList,
    loginRequired: true,
    allowPermissions: ['list_user', 'list_agency', 'list_user_agency'],
  },
  {
    path: AGENCY.LIST,
    name: 'UserAgencyLIST',
    component: ScreenUserAgencyList,
    loginRequired: true,
    allowPermissions: ['list_user_agency', 'list_ownership_useragency'],
  },
];

export default usersRoutes;
